module.exports = __webpack_public_path__ + "img/step_cright_img05new.5f2f0bef.png";